import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { ConnectorShape } from '../shape';
import { baseAnnotationChannels, basePostInference, basePreInference } from './utils';
import { Link } from './link';
var shape = {
  connector: ConnectorShape
};
export var Connector = function Connector() {
  return Link.apply(void 0, arguments);
};
Connector.props = {
  defaultShape: 'connector',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseAnnotationChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }]),
  preInference: _toConsumableArray(basePreInference()),
  postInference: _toConsumableArray(basePostInference())
};